import { AfterViewInit, Directive, Host, Input, OnChanges } from '@angular/core';

import { Instance } from 'flatpickr/dist/types/instance';
import { Ng2FlatpickrComponent } from 'ng2-flatpickr';

/**
 * Define a data mínima do calendário do ng2-flatpickr (ex.: data final não anterior à inicial).
 * O componente só lê a configuração na criação, por isso o limite é aplicado na instância do
 * flatpickr sempre que muda.
 */
@Directive({
  selector: 'ng2-flatpickr[dataMinima]'
})
export class Ng2FlatpickrPeriodoDirective implements AfterViewInit, OnChanges {
  @Input() dataMinima: Date | Date[] | string;

  constructor(@Host() private _componente: Ng2FlatpickrComponent) {}

  ngAfterViewInit(): void {
    this._aplicarDataMinima();
  }

  ngOnChanges(): void {
    this._aplicarDataMinima();
  }

  private _aplicarDataMinima(): void {
    const instancia = this._componente.flatpickr as Instance;

    if (!instancia?.set) {
      return;
    }

    // O valor do ng2-flatpickr no formulário é a lista de datas selecionadas
    const data = Array.isArray(this.dataMinima) ? this.dataMinima[0] : this.dataMinima;

    instancia.set('minDate', data || undefined);
  }
}
